// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
    display: flex;
    flex-direction: row;
    height: 50vh;
    max-width: 100%;
    margin: 0 auto;
    /*border: 1px solid #ccc;
    border-radius: 8px;*/
    overflow: hidden;
}
.icon {
  width: 10px;
  height: 10px;
  margin-right:8px;
}
.chat-sessions {
    width: 30%;
    
    padding: 10px;
    box-sizing: border-box;
    /* overflow-y: auto; Add vertical scroll */
}
.chat-sessions h3 {
    margin-top: 0;
}

.chat-sessions ul {
    list-style-type: none;
    padding: 0;
}

.chat-sessions li {
    margin-bottom: 10px;
    cursor: pointer;
}
.chat-content-kb {
    width: 70%;
    display: flex;
    flex-direction: column;
    
}

.chat-log-kb {
    flex: 1 1;
    padding: 80px;
    overflow-y: auto;
    overflow-x: auto;
    background-color: white;
}

.chat-message-kb {
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 4px;
    background-color: #fcfcfc;
}
.chat-message-kb-right {
    background-color: #fafafa;
    align-self: flex-end;
    text-align: right;
}

.chat-message-kb-left {
    background-color: #ffffff;
    align-self: flex-start;
    text-align: left;
}
.chat-query-kb {
    margin: 0;
    /* font-weight: bold; */
    text-align: right;
}
.chat-query-kb-right {
    text-align: right;
}

.chat-query-kb-left {
    text-align: left;
}

.chat-response {
    margin: 0;
    color: #555;
}

.chat-input-container-kb {
    width: 90%;
    padding: 10px;
    display: flex;
   justify-content:center; /* allow wrapper to grow instead of centering */
    align-items: center;
    background-color: #fff;
}
.chat-form {
  display: flex;
  width: 90%;  /* crucial */
}
.chat-input-kb {
    
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 32px; /* Make the border beautifully round */
    margin-right: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow to create floating effect */
    background-color: #fff; /* Ensure background is white */
    transition: box-shadow 0.3s ease; /* Smooth transition for shadow */
}

.chat-input:focus {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Enhance shadow on focus */
}
/* New task styling */
.new-task-kb {
    border: 1px solid #fcfcfc;
    border-radius: 0px;
    margin-bottom: 1px;
    padding-top:5px;
    padding-bottom:5px;
    background-color: #ffffff;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.1);
}

.new-task-kb:hover {
        background-color: #f3f2f2;
    
    border-radius: 8px;
}
.chat-button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    background-color: #007bff;
    color: #fff;
    cursor: pointer;
}

.chat-button:hover {
    background-color: #0056b3;
}

.input-wrapper-kb {
   position: relative;
    flex: 1 1;                  /* let wrapper expand */
    margin: 0 10px;           /* optional horizontal margin */
    
}

.input-plus-icon {
    position: absolute;
    left: 20px;
    top: 45%;
    transform: translateY(-50%);
    font-size: 30px;
    
    color: #777;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.chat-input-kb {
    width: 100%; 
    padding: 20px;
    
    /* ✅ Add left padding so text doesn't overlap the + icon */
    padding-left: 52px;

    font-size: 14px;
    border-radius: 32px;
    border: 1px solid #ccc;
    outline: none;
    margin-right: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow to create floating effect */
    background-color: #fff; /* Ensure background is white */
    transition: box-shadow 0.3s ease; /* Smooth transition for shadow */
}

.chat-input-kb:focus {
    border-color: #888;
}
`, "",{"version":3,"sources":["webpack://./src/ai/kb/chat/ChatView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd;wBACoB;IACpB,gBAAgB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;IACI,UAAU;;IAEV,aAAa;IACb,sBAAsB;IACtB,0CAA0C;AAC9C;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;GACd,sBAAsB,EAAE,+CAA+C;IACtE,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;EACE,aAAa;EACb,UAAU,GAAG,YAAY;AAC3B;AACA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,sCAAsC;IAC3D,kBAAkB;IAClB,wCAAwC,EAAE,yCAAyC;IACnF,sBAAsB,EAAE,+BAA+B;IACvD,gCAAgC,EAAE,iCAAiC;AACvE;;AAEA;IACI,yCAAyC,EAAE,4BAA4B;AAC3E;AACA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;QACQ,yBAAyB;;IAE7B,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;GACG,kBAAkB;IACjB,SAAO,mBAAmB,uBAAuB;IACjD,cAAc,YAAY,+BAA+B;;AAE7D;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;;IAEf,WAAW;IACX,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;;IAEb,0DAA0D;IAC1D,kBAAkB;;IAElB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,wCAAwC,EAAE,yCAAyC;IACnF,sBAAsB,EAAE,+BAA+B;IACvD,gCAAgC,EAAE,iCAAiC;AACvE;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".chat-container {\n    display: flex;\n    flex-direction: row;\n    height: 50vh;\n    max-width: 100%;\n    margin: 0 auto;\n    /*border: 1px solid #ccc;\n    border-radius: 8px;*/\n    overflow: hidden;\n}\n.icon {\n  width: 10px;\n  height: 10px;\n  margin-right:8px;\n}\n.chat-sessions {\n    width: 30%;\n    \n    padding: 10px;\n    box-sizing: border-box;\n    /* overflow-y: auto; Add vertical scroll */\n}\n.chat-sessions h3 {\n    margin-top: 0;\n}\n\n.chat-sessions ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.chat-sessions li {\n    margin-bottom: 10px;\n    cursor: pointer;\n}\n.chat-content-kb {\n    width: 70%;\n    display: flex;\n    flex-direction: column;\n    \n}\n\n.chat-log-kb {\n    flex: 1;\n    padding: 80px;\n    overflow-y: auto;\n    overflow-x: auto;\n    background-color: white;\n}\n\n.chat-message-kb {\n    margin-bottom: 10px;\n    padding: 10px;\n    border-radius: 4px;\n    background-color: #fcfcfc;\n}\n.chat-message-kb-right {\n    background-color: #fafafa;\n    align-self: flex-end;\n    text-align: right;\n}\n\n.chat-message-kb-left {\n    background-color: #ffffff;\n    align-self: flex-start;\n    text-align: left;\n}\n.chat-query-kb {\n    margin: 0;\n    /* font-weight: bold; */\n    text-align: right;\n}\n.chat-query-kb-right {\n    text-align: right;\n}\n\n.chat-query-kb-left {\n    text-align: left;\n}\n\n.chat-response {\n    margin: 0;\n    color: #555;\n}\n\n.chat-input-container-kb {\n    width: 90%;\n    padding: 10px;\n    display: flex;\n   justify-content:center; /* allow wrapper to grow instead of centering */\n    align-items: center;\n    background-color: #fff;\n}\n.chat-form {\n  display: flex;\n  width: 90%;  /* crucial */\n}\n.chat-input-kb {\n    \n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 32px; /* Make the border beautifully round */\n    margin-right: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow to create floating effect */\n    background-color: #fff; /* Ensure background is white */\n    transition: box-shadow 0.3s ease; /* Smooth transition for shadow */\n}\n\n.chat-input:focus {\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Enhance shadow on focus */\n}\n/* New task styling */\n.new-task-kb {\n    border: 1px solid #fcfcfc;\n    border-radius: 0px;\n    margin-bottom: 1px;\n    padding-top:5px;\n    padding-bottom:5px;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.1);\n}\n\n.new-task-kb:hover {\n        background-color: #f3f2f2;\n    \n    border-radius: 8px;\n}\n.chat-button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    background-color: #007bff;\n    color: #fff;\n    cursor: pointer;\n}\n\n.chat-button:hover {\n    background-color: #0056b3;\n}\n\n.input-wrapper-kb {\n   position: relative;\n    flex: 1;                  /* let wrapper expand */\n    margin: 0 10px;           /* optional horizontal margin */\n    \n}\n\n.input-plus-icon {\n    position: absolute;\n    left: 20px;\n    top: 45%;\n    transform: translateY(-50%);\n    font-size: 30px;\n    \n    color: #777;\n    cursor: pointer;\n    user-select: none;\n}\n\n.chat-input-kb {\n    width: 100%; \n    padding: 20px;\n    \n    /* ✅ Add left padding so text doesn't overlap the + icon */\n    padding-left: 52px;\n\n    font-size: 14px;\n    border-radius: 32px;\n    border: 1px solid #ccc;\n    outline: none;\n    margin-right: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow to create floating effect */\n    background-color: #fff; /* Ensure background is white */\n    transition: box-shadow 0.3s ease; /* Smooth transition for shadow */\n}\n\n.chat-input-kb:focus {\n    border-color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
